export default 'would recommend this app'
